var r=function(){return Math.random().toString(16).slice(2)};export{r as generateUniqID};
